module.exports = __webpack_public_path__ + "img/blueRightArrow.a6c225ab.svg";